<template>
    <TemplateGalleryHtmlCard
        show-header
        :selected="selected"
        :disabled="disabled"
        :template="template"
        :preview-logo-branding-center-enabled="previewLogoBrandingCenterEnabled"
    >
        <template #menu>
            <slot name="menu" />
        </template>

        <template #overlay>
            <div class="template-overlay">
                <DsFilledButton
                    class="select-button"
                    data-qa="select-button"
                    @click="handleClick"
                >
                    {{ $t('unlayerBuilder.templateSelection.selectTemplate') }}
                </DsFilledButton>

                <DsTextButton
                    v-if="previewEnabled"
                    class="preview-button"
                    leading-icon="eye-show"
                    data-qa="broadcast-preview-button"
                    @click="$emit('preview')"
                >
                    {{ $t('global.preview') }}
                </DsTextButton>
            </div>
        </template>
    </TemplateGalleryHtmlCard>
</template>

<script>
import { targetContainsClickEvent } from '@/utils/events';
import TemplateGalleryHtmlCard from './TemplateGalleryHtmlCard';

export default {
    name: 'TemplateGalleryUnlayerCard',

    components: {
        TemplateGalleryHtmlCard,
    },

    props: {
        template: {
            type: Object,
            required: true,
        },
        showHeader: {
            type: Boolean,
            default: true,
        },
        selected: Boolean,
        disabled: Boolean,
        previewEnabled: Boolean,
        previewLogoBrandingCenterEnabled: Boolean,
    },

    emits: ['click', 'preview'],

    methods: {
        handleClick(event) {
            if (!targetContainsClickEvent(event, this.$refs.menu)) {
                this.$emit('click');
            }
        },
    },
};
</script>

<style lang="scss" scoped>

.template-overlay {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba($color-paper, .7);
}

.select-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    --icon-size: 1rem;

    span {
        @include margin-start($spacing-100);
    }
}

.preview-button {
    margin-top: $spacing-100;
    align-items: center;
}

</style>
